import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 16v-8l3 5l3 -5v8","key":"svg-0"}]]

const IconLetterMSmall = createReactComponent('outline', 'letter-m-small', 'LetterMSmall', __iconNode);

export default IconLetterMSmall;